import { render, staticRenderFns } from "./VirtualTable.vue?vue&type=template&id=70696401&scoped=true&"
import script from "./VirtualTable.vue?vue&type=script&lang=ts&"
export * from "./VirtualTable.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualTable.vue?vue&type=style&index=0&id=70696401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70696401",
  null
  
)

export default component.exports